import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar"
export default class extends Controller {
  toggleLanguageDropdown() {
    const dropdown = document.getElementById("language-dropdown")
    dropdown.classList.toggle("open")
    dropdown.classList.toggle("scale-95")
    dropdown.classList.toggle("-translate-y-2")
    dropdown.classList.toggle("pointer-events-none")

    dropdown.classList.toggle("opacity-100")
    dropdown.classList.toggle("scale-100")
    dropdown.classList.toggle("translate-y-0")

    document.getElementById('language-dropdown-backdrop').classList.toggle('hidden')
  }

  toggleUserDropdown() {
    document.getElementById('user-dropdown').classList.toggle('hidden')
    document.getElementById('backdrop').classList.toggle('hidden')
  }

  toggleOrganizationDropdown() {
    document.getElementById('select-organization-container').classList.toggle('hidden')
  }
}
